<template>
  <div
    class="timeline-marker playlist-item"
    :class="{ editing: isEditing }"
    data-component-type="marker"
    :style="{ '--marker-color': markerColor }"
    @click="onClickTimelineItem"
  >
    <button
      class="timeline-marker__drag drag-handle"
      title="Rearrange"
      type="button"
    >
      <span class="fas fa-grip-vertical"></span>
    </button>

    <div class="timeline-marker__center">
      <span class="timeline-marker__line" />

      <div
        :title="title"
        class="timeline-marker__title"
      >
        {{ title }}
      </div>

      <span class="timeline-marker__line" />
    </div>

    <dropdown position="left" class="timeline-marker__menu more-actions">
      <template #trigger>
        <button class="tb-btn tb-btn-text sm medium-em" title="More actions">
          <span class="fas fa-ellipsis-v"></span>
        </button>
      </template>
      <template #dropdown-body>
        <button
          class="dropdown-list-item"
          v-on:click="duplicateItem"
        >
          <span class="dropdown-list-item-label">Duplicate in Playlist</span>
        </button>

        <button
          v-if="canDuplicateInGroup"
          class="dropdown-list-item"
          v-on:click="duplicateItemInGroup"
        >
          <span class="dropdown-list-item-label">Duplicate in Group</span>
        </button>

        <hr>

        <button
          class="dropdown-list-item"
          v-on:click="removeItem"
        >
          <span class="dropdown-list-item-label warning">
            Remove
          </span>
        </button>
      </template>
    </dropdown>
  </div>
</template>

<script>
import TimelineMixins from '../../mixins/timeline-mixins';
import Dropdown from '../../shared/dropdown/Dropdown.vue';

export default {
  name: 'TimelineMarkerComponent',
  mixins: [TimelineMixins],

  components: {
    Dropdown,
  },

  data() {
    return {};
  },

  computed: {
    title() {
      return this.item.title;
    },

    markerColor() {
      return this.item?.fields?.color || this.item?.color || '#CC9F10';
    },
  },
};
</script>

<style scoped lang="scss">
.timeline-marker {
  position: relative;
  border: 1px dashed transparent;
  border-radius: 10px;
  display: flex;
  align-items: center;
  min-height: 35px;
  padding: 0 4px;
  cursor: pointer;

  &:hover {
    z-index: 2;
  }

  &.editing {
    border-color: var(--marker-color, #CC9F10);
  }

  &__drag {
    border: 0;
    background: transparent;
    color: #e7e7e7;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }

  &__center {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  &__line {
    height: 1px;
    flex: 1;
    min-width: 24px;
    background: var(--marker-color, #CC9F10);
  }

  &__title {
    color: var(--marker-color, #CC9F10);
    font-weight: 600;
    text-align: center;
    white-space: nowrap;
  }

  &__menu {
    position: relative;
    z-index: 3;
  }
}
</style>
